import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormGroup } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { change, formValueSelector, reduxForm } from 'redux-form';

import { url } from '../../config';
import FooterButton from './FooterButton';
import SidePanel from './SidePanel';
import stepThreeIllustration from '/public/SiteImages/step3.svg';

import bt from '../../components/commonStyle.css';
import s from './ListPlaceStep1.css';
import DefaultIcon from '/public/SiteIcons/defaultIcon.png';
// Validate
import updateStep2 from './updateStep2';
// Helpers
import validateStep2 from './validateStep2';

class AmenitiesSpaces extends Component {

  static propTypes = {
    initialValues: PropTypes.object,
    previousPage: PropTypes.any,
    nextPage: PropTypes.any,
    formValues: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      essentialsAmenities: [],
      safetyAmenities: [],
      spaces: [],
    };
  }

  UNSAFE_componentWillMount() {
    const { listingFields } = this.props;
    if (listingFields) {
      this.setState({
        essentialsAmenities: listingFields.essentialsAmenities || [],
        safetyAmenities: listingFields.safetyAmenities || [],
        spaces: listingFields.spaces || [],
      });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { listingFields } = nextProps;
    if (listingFields) {
      this.setState({
        essentialsAmenities: listingFields.essentialsAmenities || [],
        safetyAmenities: listingFields.safetyAmenities || [],
        spaces: listingFields.spaces || [],
      });
    }
  }

  handleToggle(fieldName, optionId) {
    const current = this.props.formValues[fieldName] || [];
    const newValue = [...current];
    const idx = newValue.indexOf(optionId);
    if (idx !== -1) {
      newValue.splice(idx, 1);
    } else {
      newValue.push(optionId);
    }
    this.props.dispatch(change('ListPlaceStep2', fieldName, newValue));
  }

  render() {
    const { handleSubmit, previousPage, formPage, step, existingList, nextPage, formValues } = this.props;
    const { formatMessage } = this.props.intl;
    const { essentialsAmenities, safetyAmenities, spaces } = this.state;

    const allOptions = [
      ...essentialsAmenities.filter(o => o.isEnable === "1").map(o => ({ ...o, fieldName: 'amenities' })),
      ...safetyAmenities.filter(o => o.isEnable === "1").map(o => ({ ...o, fieldName: 'safetyAmenities' })),
      ...spaces.filter(o => o.isEnable === "1").map(o => ({ ...o, fieldName: 'spaces' })),
    ].sort((a, b) => (a.itemName || '').localeCompare(b.itemName || ''));

    let path = "index";
    if (existingList) {
      path = "home";
    }

    return (
      <div className={s.eslipinBg}>
        <div className={s.grid}>
          <SidePanel
            badge="Información del alojamiento"
            title={`Selecciona las \n`}
            highlightText="comodidades y servicios"
            subtitle={`Marca todas las opciones que ofreces \n en tu alojamiento`}
            iconImg={stepThreeIllustration}
          />
          <form onSubmit={handleSubmit}>
            <div className={s.stepRightCard}>
              <div className={s.landingMainContent}>
                <h2 className={s.amenitiesSpacesTitle}>
                  Comodidades y servicios
                </h2>
                <p className={cx('photoUploadSubtitle')}>
                  Marca todas las opciones que ofreces en tu alojamiento.
                </p>
                <FormGroup className={s.formGroup}>
                  <div className={s.amenityGrid}>
                    {allOptions.map((option) => {
                      const fieldArray = formValues ? formValues[option.fieldName] : [];
                      const isActive = fieldArray && fieldArray.indexOf(option.id) !== -1;
                      return (
                        <div
                          key={option.fieldName + '-' + option.id}
                          className={cx(s.roomTypeOption, s.amenityCardRow, { [s.roomTypeOptionActive]: isActive })}
                          onClick={() => this.handleToggle(option.fieldName, option.id)}
                        >
                          <div className={s.amenityRowIcon}>
                            {option.image ? (
                              <img src={url + '/images/amenities/' + option.image} alt={option.itemName} />
                            ) : (
                              <img src={DefaultIcon} alt={option.itemName} />
                            )}
                          </div>
                          <h3 className={s.roomTypeCardTitle}>{option.itemName}</h3>
                          <div className={s.roomTypeRadioWrapper}>
                            {isActive ? (
                              <span className={s.roomTypeRadioChecked}>
                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                                  <path d="M2.5 6.2L4.8 8.5L9.5 3.5" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                              </span>
                            ) : (
                              <span className={s.roomTypeRadioUnchecked} />
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </FormGroup>
              </div>
              <FooterButton
                previousPage={previousPage}
                previousPagePath={path}
                nextPage={nextPage}
                nextPagePath={"photos"}
                formPage={formPage}
                step={step}
              />
            </div>
          </form>
        </div>
      </div>
    );
  }
}

AmenitiesSpaces = reduxForm({
  form: 'ListPlaceStep2',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  onSubmit: updateStep2,
  validate: validateStep2,
})(AmenitiesSpaces);

const selector = formValueSelector('ListPlaceStep2');

const mapState = (state) => ({
  listingFields: state.listingFields.data,
  existingList: state.location.isExistingList,
  formValues: {
    amenities: selector(state, 'amenities'),
    safetyAmenities: selector(state, 'safetyAmenities'),
    spaces: selector(state, 'spaces'),
  },
});

const mapDispatch = {};

export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(AmenitiesSpaces)));
